import React from 'react';

interface LogoProps {
    className?: string;
    variant?: 'full' | 'symbol';
}

export const Logo: React.FC<LogoProps> = ({ className = "w-12 h-12", variant = 'full' }) => {
    const logoSrc = variant === 'symbol' ? '/brand-logo-symbol.svg' : '/brand-logo.svg';

    return (
        <img
            src={logoSrc}
            alt="PolyBid Logo"
            className={`object-contain ${className}`}
        />
    );
};
